import React from 'react'
import { SendOutlined, PlusOutlined, StopOutlined } from '@ant-design/icons'

interface InputAreaProps {
  inputValue: string
  hasInput: boolean
  isLoading: boolean
  onInputChange: (value: string) => void
  onSend: () => void
  onStop: () => void
  onNewChat: () => void
  onKeyDown: (e: React.KeyboardEvent<HTMLTextAreaElement>) => void
}

export const InputArea: React.FC<InputAreaProps> = ({
  inputValue,
  hasInput,
  isLoading,
  onInputChange,
  onSend,
  onStop,
  onNewChat,
  onKeyDown
}) => {
  return (
    <div className="bottom-fixed-area">
      <div className="input-container">
        <div className="input-box-wrapper">
          <textarea
            placeholder="输入你想咨询的相关问题..."
            value={inputValue}
            onChange={(e) => onInputChange(e.target.value)}
            onKeyDown={onKeyDown}
            rows={1}
          />

          <div className="input-toolbar">
            <div className="tool-left"></div>
            <div className="tool-right">
              <button className="btn-new-chat" onClick={onNewChat}>
                <PlusOutlined /> 开启新对话
              </button>
              {isLoading ? (
                <button
                  className="btn-stop"
                  onClick={onStop}
                >
                  <StopOutlined />
                </button>
              ) : (
                <button
                  className={`btn-send ${hasInput ? 'active' : ''}`}
                  onClick={onSend}
                  disabled={!hasInput}
                >
                  <SendOutlined />
                </button>
              )}
            </div>
          </div>
        </div>

        <div className="footer-note">
          以上内容由大模型生成，仅供参考
        </div>
      </div>
    </div>
  )
}
